import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugCelecoxib} from "./TextDrugCelecoxib"


export default function Celecoxib() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
  
    <ButtonsText onClick={handleOpen} name=' Celecoxib' size='large' color='common.white' />

    <CustomDialog open={open} onClose={handleClose}

        title="Celecoxib - PGx Recommendation"
        content={ <TextDrugCelecoxib />}

        />

</>
)}